<template>
    <views>
        <views class="point-source-total">
            <views>
                <views class="p-box">
                    <images :src="pointBg"></images>
<!--                  TODO 写死积分-->
<!--                    <views class="count">{{ totalPoint }}</views>-->
                  <views class="count">86</views>
                </views>
                <views class="p-title">我的积分</views>
            </views>
        </views>
        <van-list
            v-model="loadingData"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
            <views
                v-for="(item, index) in list"
                :key="index">
                <views class="point-source-list">
                    <views class="title">{{ item.source }}</views>
                    <views class="count">+{{ item.point }}</views>
                </views>
            </views>
        </van-list>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
import api from '@/utils/api'
import storage from '@/utils/storage'
export default {
    mixins: [tools],
    data() {
        return {
            loadingData: false,
            finished: false,
            pageNum: 1,
            list: [],
            pointBg: require('@/assets/images/point_bg.png')
        }
    },
    computed: {
        totalPoint() {
            return JSON.parse(storage.get('member')).point
        }
    },
    methods: {
        onLoad() {
            const params = {
                page: this.pageNum,
                page_size: 30
            }
            api.getPointSourceList(params).then((res) => {
                if (res.data.list && res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.list.push({ ...item })
                    })
                    this.pageNum++
                    this.loadingData = false
                    if (res.data.list.length < 10) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
